import { useEffect, useState } from "react";

// Phone layout: below 600px (rendered conditionally in JS via matchMedia).
export const PHONE_QUERY = "(max-width: 599px)";

export function readIsPhone(): boolean {
  return typeof window !== "undefined" && typeof window.matchMedia === "function" ? window.matchMedia(PHONE_QUERY).matches : false;
}

export function useIsPhone(): boolean {
  const [isPhone, setIsPhone] = useState(readIsPhone);
  useEffect(() => {
    if (typeof window.matchMedia !== "function") return;
    const mq = window.matchMedia(PHONE_QUERY);
    const handler = (e: MediaQueryListEvent) => setIsPhone(e.matches);
    mq.addEventListener?.("change", handler);
    return () => mq.removeEventListener?.("change", handler);
  }, []);
  return isPhone;
}
